import React, { useEffect, useState } from "react";
import { authService } from "../services/authService";

function AdminDashboard({ onLogout }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeMenu, setActiveMenu] = useState("users");
  const currentUser = authService.getUser();

  useEffect(() => {
    const loadUsers = async () => {
      setLoading(true);
      setError("");

      const result = await authService.getUsers();

      if (result.success) {
        setUsers(result.users);
      } else {
        setError(result.message || "Unable to load users");
      }

      setLoading(false);
    };

    loadUsers();
  }, []);

  return (
    <div style={styles.page}>
      <aside style={styles.sidebar}>
        <div>
          <p style={styles.eyebrow}>KansasRoot</p>
          <h1 style={styles.sidebarTitle}>Admin Dashboard</h1>
          <p style={styles.sidebarText}>
            Signed in as {currentUser?.firstName} {currentUser?.lastName}
          </p>
        </div>

        <div style={styles.menuGroup}>
          <button
            type="button"
            onClick={() => setActiveMenu("users")}
            style={{
              ...styles.menuButton,
              ...(activeMenu === "users" ? styles.menuButtonActive : {}),
            }}
          >
            User List
          </button>
        </div>

        <button type="button" onClick={onLogout} style={styles.logoutButton}>
          Logout
        </button>
      </aside>

      <main style={styles.content}>
        <div style={styles.contentHeader}>
          <div>
            <p style={styles.sectionLabel}>Admin Menu</p>
            <h2 style={styles.contentTitle}>User List</h2>
          </div>
        </div>

        <section style={styles.panel}>
          {loading && <p style={styles.stateText}>Loading users...</p>}
          {error && !loading && <div style={styles.errorMessage}>{error}</div>}

          {!loading && !error && (
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>ID</th>
                    <th style={styles.th}>Name</th>
                    <th style={styles.th}>Email</th>
                    <th style={styles.th}>Role</th>
                    <th style={styles.th}>Company</th>
                    <th style={styles.th}>Address</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id}>
                      <td style={styles.td}>{user.id}</td>
                      <td style={styles.td}>
                        {user.firstName} {user.lastName}
                      </td>
                      <td style={styles.td}>{user.email}</td>
                      <td style={styles.td}>{user.role}</td>
                      <td style={styles.td}>{user.companyName || "N/A"}</td>
                      <td style={styles.td}>{user.address || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    gridTemplateColumns: "280px 1fr",
    background: "#f3f4f6",
  },
  sidebar: {
    background: "linear-gradient(180deg, #102a43 0%, #1f3c88 100%)",
    color: "#fff",
    padding: "2rem 1.5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "2rem",
  },
  eyebrow: {
    margin: 0,
    color: "#9fb3c8",
    textTransform: "uppercase",
    letterSpacing: "0.12em",
    fontSize: "0.75rem",
  },
  sidebarTitle: {
    margin: "0.4rem 0 0.75rem",
    fontSize: "2rem",
    lineHeight: 1.1,
  },
  sidebarText: {
    margin: 0,
    color: "#d9e2ec",
    lineHeight: 1.5,
  },
  menuGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  menuButton: {
    border: "1px solid rgba(255, 255, 255, 0.18)",
    background: "rgba(255, 255, 255, 0.08)",
    color: "#fff",
    borderRadius: "12px",
    padding: "0.95rem 1rem",
    textAlign: "left",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
  },
  menuButtonActive: {
    background: "#fff",
    color: "#102a43",
  },
  logoutButton: {
    background: "#d64545",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    padding: "0.95rem 1rem",
    fontSize: "1rem",
    fontWeight: "700",
    cursor: "pointer",
  },
  content: {
    padding: "2rem",
  },
  contentHeader: {
    marginBottom: "1.5rem",
  },
  sectionLabel: {
    margin: 0,
    color: "#486581",
    textTransform: "uppercase",
    letterSpacing: "0.12em",
    fontSize: "0.75rem",
  },
  contentTitle: {
    margin: "0.5rem 0 0",
    color: "#102a43",
    fontSize: "2rem",
  },
  panel: {
    background: "#fff",
    borderRadius: "20px",
    padding: "1.5rem",
    boxShadow: "0 18px 50px rgba(15, 23, 42, 0.08)",
    border: "1px solid #e5e7eb",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    padding: "0.9rem 1rem",
    background: "#f8fafc",
    color: "#334e68",
    fontSize: "0.88rem",
    borderBottom: "1px solid #d9e2ec",
  },
  td: {
    padding: "0.95rem 1rem",
    borderBottom: "1px solid #e5e7eb",
    color: "#243b53",
    verticalAlign: "top",
  },
  stateText: {
    margin: 0,
    color: "#52606d",
  },
  errorMessage: {
    color: "#b42318",
    background: "#fef3f2",
    border: "1px solid #fecdca",
    borderRadius: "12px",
    padding: "0.9rem 1rem",
  },
};

export default AdminDashboard;
